import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className,
  href,
  variant = 'primary',
  fullWidth = false,
  onClick,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-black uppercase tracking-wide transition-all duration-300 transform hover:scale-105 active:scale-95 rounded-lg py-3 px-6 text-sm md:text-base leading-none shadow-xl';
  const variants = {
    primary: 'bg-[#D4A843] hover:bg-[#E0B84E] hover:brightness-120 text-white border-b-4 border-[#B8922E] glow-gold',
    secondary: 'bg-[#102A1F] hover:bg-[#1A3D2D] text-white border-b-4 border-[#0B1F17] glow-green'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    if (onClick) onClick(e as any);
  };
  if (href) {
    return <a href={href} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className || ''}`} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-34">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className || ''}`} {...props} data-id="element-35">
      {children}
    </button>;
}